<template>
  <div class="box">
    <div class="shadow"></div>
    <div class="loginMsg">
      <p>活动规则</p>
      <div class="msg" v-if="idx==0">
        <p class="head">每日抽奖活动说明</p>
        <p class="content">
          1、活动时间：长期有效；
          <br />2、消耗10积分即可参与抽奖；
          <br />3、积分和雷币即时到账；
          <br />4、其他奖品请在请在3个工作日内填写收货信息，并仔细核对，过期作放弃处理；奖品会在7个工作日内发放，忘记领奖可在【我的奖品】补领；
          <br />5、禁止各种作弊行为，包括但不限于使用破解，多开小号等，违者取消获奖资格；
          <br />6、每天单个账号最多可抽奖10次；
          <br />7、本活动最终解释权归雷电圈所有，如有疑问请加Q群：788401286。
        </p>
      </div>
      <div class="msg" v-if="idx==1">
        <p class="head">积分竞猜活动说明</p>
        <p class="content">
          1、活动时间：每周一次，周一开奖；
          <br />2、消耗积分可参与竞猜，猜对者瓜分奖池内所有积分；
          <br />3、禁止各种作弊行为，违者取消资格；
          <br />4、本活动最终解释权归雷电圈所有，如有疑问请加Q群：788401286。
        </p>
      </div>
      <div class="msg" v-if="idx==2">
        <p class="head">积分兑换</p>
        <p class="content">
          1、实物兑换需仔细填写收货地址，商品会在领取完毕后15个工作日内发送；
          <br />2、Q币兑换需仔细填写QQ号以及其他信息，商品会在3个工作日内充值到账；
          <br />3、京东卡兑换需加客服QQ：2563224109领取；
          <br />4、如有疑问请加Q群：788401286。
          <br />
        </p>
      </div>
      <div class="cancel" @click="handleCancle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    idx: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleCancle() {
      this.$emit("cancle");
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.loginMsg {
  position: absolute;
  border-radius: 10px;
  left: 50%;
  top: 29%;
  transform: translateX(-50%);
  width: 660px;
  text-align: center;
  font-size: 30px;
  background: #fff;
  z-index: 99999;
  padding: 35px 35px 0;
  .msg {
    width: 100%;
    margin-top: 40px;
    text-align: left;
    .head {
      font-size: 28px;
      color: #7534d6;
    }
    .content {
      color: #878787;
      margin-top: 20px;
      font-size: 24px;
      line-height: 32px;
    }
  }
}
.shadow {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.5;
}
.cancel {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  bottom: -100px;
  height: 48px;
  width: 48px;
  background: url("../assets/guanbi.png") no-repeat;
  background-size: 100% 100%;
}
</style>
